export default "__VITE_ASSET__D6MHLCTp__"